import $ from "jquery";

import { func_validation, isNotNullUndefined } from "./func_validation";
import { func_url } from "./func_url";

export const func_serviceHandling = {

    createUrlWithParams,

	requestAjaxGet,
	requestAjaxGetText,
	requestAjaxGetTextSync,

	requestAjaxPost,
	requestAjaxPostNoData,
	requestAjaxPostText,
	requestAjaxPostTextNoData,

	requestAjaxPut,
	requestAjaxPutNoData,
	
    requestAjaxDelete,
    requestAjaxDeleteNoData,

};

function createUrlWithParams(url, paramObj, defaultObj) {
    let paramArray = [];
    for (let key in paramObj) {
        let defaultValue = func_validation.getObjectPropertyValue(defaultObj, key, "");
        let paramSet = isNotNullUndefined(paramObj[key])? paramObj[key]: defaultValue;
        paramArray.push(func_url.setFormatQueryString(key, paramSet));
    }

    let paramArray_formatted = func_validation.filterNegatedElementFromArray(paramArray);

    let url_formatted = "";
    if (func_validation.isStringTrimNotEmpty(url)) url_formatted = url;
    else return "";

    return func_url.combineUrlAndQueryString(url_formatted + "?", paramArray_formatted);
}

function requestAjaxGet(url) {
    return $.ajax({
        type: "GET",
        url: url,
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxGetText(url) {
    return $.ajax({
        type: "GET",
        url: url,
        contentType: "application/json;charset=utf-8",
        dataType: "text",
    });
}

function requestAjaxGetTextSync(url) {
    return $.ajax({
        type: "GET",
        url: url,
        contentType: "application/json;charset=utf-8",
        dataType: "text",
        async: false,
    });
}

function requestAjaxPost(url, data) {
    return $.ajax({
        type: "POST",
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxPostNoData(url) {
    return $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxPostText(url, data) {
    return $.ajax({
        type: "POST",
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json;charset=utf-8",
        dataType: "text",
    });
}

function requestAjaxPostTextNoData(url) {
    return $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json;charset=utf-8",
        dataType: "text",
    });
}

function requestAjaxPut(url, data) {
    return $.ajax({
        type: "PUT",
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxPutNoData(url) {
    return $.ajax({
        type: "PUT",
        url: url,
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxDelete(url, data) {
    return $.ajax({
        type: "DELETE",
        url: url,
        data: JSON.stringify(data),
        contentType: "application/json;charset=utf-8",
    });
}

function requestAjaxDeleteNoData(url) {
    return $.ajax({
        type: "DELETE",
        url: url,
        contentType: "application/json;charset=utf-8",
    });
}
